import TablaConciliacion from "../../../TablaConciliacion";

function TablaLaPintada() {
  return <TablaConciliacion nombreUseCase="LAPINTADA" titulo="LA PINTADA" />;
}

export default TablaLaPintada;
